import React, { useState } from 'react';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import ForgotPasswordPage from './ForgotPasswordPage';

const AuthModal = ({ isOpen, onClose, initialMode = 'login' }) => {
  const [currentMode, setCurrentMode] = useState(initialMode);

  if (!isOpen) return null;

  const handleClose = () => {
    setCurrentMode('login');
    onClose();
  };

  switch (currentMode) {
    case 'signup':
      return (
        <SignupPage
          onClose={handleClose}
          onSwitchToLogin={() => setCurrentMode('login')}
        />
      );
    case 'forgot-password':
      return (
        <ForgotPasswordPage
          onClose={handleClose}
          onSwitchToLogin={() => setCurrentMode('login')}
        />
      );
    default:
      return (
        <LoginPage
          onClose={handleClose}
          onSwitchToSignup={() => setCurrentMode('signup')}
          onSwitchToForgotPassword={() => setCurrentMode('forgot-password')}
        />
      );
  }
};

export default AuthModal;